export const SIX_FOUR_ZERO = "640";
export const SPINACH = "Spinach";
export const HAND_HELD = "Handheld";
export const POULTRY = "Poultry";
export const EGG = "Egg";
export const PRODUCE = "Produce";
export const SEAFOOD = "Seafood";
